<template>
  <div class="grid-content cs-courseCategoryOptionEdit">
    <div
      class="loading"
      v-loading="loading"
    >
      <el-form
        ref="courseCategoryOptions"
        :model="dataModel"
        label-position="left"
        label-width="200px"
      >
        <div v-if="dataModel.ccOptionsGlobal.length > 0">
          <div>
            <span class="input-width cs-bold">全局设置：</span>
          </div>
          <el-row>
            <el-col :span="18">
              <hr>
            </el-col>
          </el-row>
          <div
            v-for="(item, index) in dataModel.ccOptionsGlobal"
            :key="index"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="item.label"
                  :prop="`ccOptionsGlobal.${index}.price`"
                  :rules="rules.price"
                >
                  <el-input
                    :disabled="optionModel.isReadonly"
                    placeholder="请输入价格"
                    v-model="item.price"
                    class="input-width"
                  >
                    <template slot="append">$</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="18">
              <hr>
            </el-col>
          </el-row>
        </div>
        <div v-if="dataModel.ugccOptionGroups.length > 0">
          <div>
            <span class="input-width cs-bold">学校分组设置：</span>
          </div>
          <el-row>
            <el-col :span="18">
              <hr>
            </el-col>
          </el-row>
          <el-row
            v-for="(group, index1) in dataModel.ugccOptionGroups"
            :key="index1"
          >
            <div v-if="!isReview">
              <span class="input-width">{{group.groupName}}</span>
            </div>
            <div
              v-for="(item, index2) in group.options"
              :key="index2"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="isReview ? group.groupName : item.label"
                    :prop="`ugccOptionGroups.${index1}.options.${index2}.price`"
                    :rules="rules.price"
                  >
                    <el-input
                      :disabled="optionModel.isReadonly"
                      placeholder="请输入价格"
                      v-model="item.price"
                      class="input-width"
                    >
                      <template slot="append">$</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :span="18">
                <hr>
              </el-col>
            </el-row>
          </el-row>
        </div>
      </el-form>
    </div>
    <el-row
      v-if="!optionModel.isReadonly"
      class="cs-filter-row"
    >
      <el-col
        :span="4"
        class="footer-left"
      >
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          :type="submitBtnClass"
          @click="saveCourseCategoryOptionsToServer"
        >保存更新</el-button>
      </el-col>
      <el-col
        :span="16"
        class="footer-right"
      >
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}
.cs-courseCategoryOptionEdit{
  /deep/ .el-input__inner{
    min-width: 100px;
  }

  /deep/ .el-form-item{
    margin-bottom : 0;
  }
}
</style>

<script>
import {
  getCourseCategoryOptionList,
  getUniversityGroupCourseCategoryOptionGroupList,
  saveCourseCategoryOptionsPrice,
  saveUniversityGroupCourseCategoryOptions
} from "@/service/common.service";

export default {
  props: {
    isActive: Boolean,
    categoryId: Number,
    isReview: Boolean,
    options: {
      isReadonly: Boolean
    }
  },
  data() {
    let validatePrice = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isLoadedData: false,
      loading: false,
      submitBtnClass: "info",
      submitBtnDisable: true,
      showError: false,
      errorMessage: "",
      courseCategoryOptions: [],
      universityGroupCourseCategoryOptionGroups: [],
      optionModel: {
        isReadonly: false
      },
      dataModel: {
        ccOptionsGlobal: [],
        ugccOptionGroups: []
      },
      rules: {
        price: [
          {
            required: true,
            message: "价格不能为空",
            trigger: "blur"
          },
          {
            validator: validatePrice,
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.init();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    async loadCourseCategoryOptionsFromServer(categoryId = this.categoryId) {
      let categoryIds = [categoryId];
      let result = await getCourseCategoryOptionList(categoryIds);
      if (!!result && result.success) {
        this.courseCategoryOptions = result.data;
      } else {
        this.courseCategoryOptions = [];
      }
    },
    async loadUniversityGroupCourseCategoryOptionGroupsFromServer(categoryId = this.categoryId) {
      let result = await getUniversityGroupCourseCategoryOptionGroupList(categoryId);
      if (!!result && result.success) {
        this.universityGroupCourseCategoryOptionGroups = result.data;
      } else {
        this.universityGroupCourseCategoryOptionGroups = [];
      }
    },
    async saveCourseCategoryOptionsToServer() {
      let isValid = this.checkAllInputs(true);
      if (!isValid) {
        return;
      }

      this.submitBtnDisable = true;

      let showError = false;
      let errorMessage = "";
      let saveData1 = this.__getGlobalSaveData();
      let result1 = { success: true };
      if (saveData1.length > 0)
        result1 = await saveCourseCategoryOptionsPrice(saveData1);
      let saveData2 = this.__getUniversityGroupSaveData();
      let result2 = { success: true };
      if (saveData2.length > 0)
        result2 = await saveUniversityGroupCourseCategoryOptions(saveData2);
      if (!!result1 && result1.success && !!result2 && result2.success) {
        this.$message({
          message: "保存更新成功",
          type: "success"
        });
        await this.init();
      } else {
        this.errorMessage = !!result ? result.message : "未连接到服务器";
        this.showError = true;
      }

      this.submitBtnDisable = false;
    },
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs(onlyCheck) {
      let isValid = true;

      let $ref = this.$refs["courseCategoryOptions"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
          }
        });
      }

      if (onlyCheck) return isValid;

      this.submitBtnClass = isValid ? "primary" : "info";
      this.submitBtnDisable = !isValid;

      return isValid;
    },
    async init() {
      if (!this.isActive){
        return;
      }
      this.loading = true;
      await this.loadCourseCategoryOptionsFromServer();
      await this.reloadDataModel();
      await this.loadUniversityGroupCourseCategoryOptionGroupsFromServer();
      await this.reloadDataModelForUniversityGroup();
      this.loading = false;
      this.isLoadedData = true;
    },
    async reloadDataModel() {
      let newData = [];
      this.courseCategoryOptions.forEach(element => {
        let item = {
          id: element.Id,
          courseCategoryId: element.CourseCategoryId,
          name: element.Name,
          label: element.Label,
          price: element.Price,
          unit: element.Unit,
          useUniversityOption: element.UseUniversityOption
        };
        if (!item.useUniversityOption) newData.push(item);
      });
      this.dataModel.ccOptionsGlobal = newData;
    },
    async reloadDataModelForUniversityGroup() {
      let newData = [];
      this.universityGroupCourseCategoryOptionGroups.forEach(element => {
        let ugccOptionGroup = {
          groupNumber: element.UniversityGroup.GroupNumner,
          groupName: element.UniversityGroup.NameValue,
          options: []
        };
        element.UniversityGroupCourseCategoryOptions.forEach(ugccOption => {
          ugccOptionGroup.options.push({
            id: ugccOption.Id,
            courseCategoryOptionId: ugccOption.CourseCategoryOptionId,
            universityGroupNumber: ugccOption.UniversityGroupNumber,
            price: ugccOption.Price,
            label: ugccOption.Label
          });
        });
        newData.push(ugccOptionGroup);
      });
      this.dataModel.ugccOptionGroups = newData;
    },
    __getGlobalSaveData() {
      var saveData = [];

      this.dataModel.ccOptionsGlobal.forEach(element => {
        saveData.push({
          Id: element.id,
          CourseCategoryId: element.courseCategoryId,
          Name: element.name,
          Label: element.label,
          Price: element.price,
          Unit: element.unit,
          UseUniversityOption: element.useUniversityOption
        });
      });

      return saveData;
    },
    __getUniversityGroupSaveData() {
      var saveData = [];

      this.dataModel.ugccOptionGroups.forEach(element => {
        element.options.forEach(option => {
          saveData.push({
            Id: option.id,
            CourseCategoryOptionId: option.courseCategoryOptionId,
            UniversityGroupNumber: option.universityGroupNumber,
            Price: option.price,
            Label: option.label
          });
        });
      });

      return saveData;
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.init();
      }
    },
    options: function(newVal) {
      this.loadOptionModelFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/courseCategoryOptionEdit.vue